import { render } from "./ConsentFormModals.vue?vue&type=template&id=373a7294&scoped=true"
import script from "./ConsentFormModals.vue?vue&type=script&lang=js"
export * from "./ConsentFormModals.vue?vue&type=script&lang=js"

import "./ConsentFormModals.vue?vue&type=style&index=0&id=373a7294&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373a7294"]])

export default __exports__